import { Link } from 'react-router-dom';
import { React, useEffect, useState } from 'react';
import { retrieveToken } from './../../../hooks/use-token';
import { handleMyPayments } from './../../../api/pagamento';

const MeusPagamentosTable = () => {
  
const [allPayments, setAllPayments] = useState([]);
const [flagApi, setFlagApi] = useState(false);

  useEffect(() => {
    
    const tokenApi = retrieveToken();
    
    if (allPayments.length == 0 && flagApi == false) {

        handleMyPayments(tokenApi).then(function(result) {
            setAllPayments(result);
            setFlagApi(true);
        });

    }

  });

  const formattedValue = (monetaryValue) => new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(monetaryValue);

  const formatDate = (dateString) => {

    const date = new Date(dateString);
    const formattedDate = date.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  
    return formattedDate;
  };

  return (
    <div className="table-content table-responsive" style={{marginTop: 35}}>
    <table className="table">
      <thead>
        <tr>
          <th className="product-thumbnail">Plano</th>
          <th className="cart-product-name">Acesso ao(s) Curso(s)</th>
          <th className="product-price">Vencimento</th>
          <th className="product-quantity">Valor</th>
          <th className="product-subtotal">Status</th>
          <th className="product-subtotal">Situação</th>
          <th className="product-remove">Imprimir</th>
        </tr>
      </thead>
      <tbody>
      {allPayments && allPayments.map((payment, index) => (
          <tr key={index}>
            <td>{(payment.plano != null) ? payment.plano.titulo : ''}</td>
            <td>
            {payment.plano != null && payment.plano.planocursos.map((planocurso, planocursoIndex) => (
              <div key={planocursoIndex}>
                {planocurso.cursos.map((curso, cursoIndex) => (
                  <p key={cursoIndex}>{curso.nome}</p>
                ))}
              </div>
            ))}
            </td>
            <td>{formatDate(payment.vencimento)}</td>
            <td>{formattedValue((payment && payment.plano && payment.plano.valor_promocao > 0.00) ? payment.plano.valor_promocao : (payment.plano && payment.plano.valor))}</td>
            <td>{payment.flag_ativo == '1' ? 'Ativo' : 'Inativo'}</td>
            <td>
              {payment.flag_status === '1' && <a className="btn btn-info" style={{color: 'white'}}>Pendente</a>}
              {payment.flag_status === '2' && <a className="btn btn-success" style={{color: 'white'}}>Pago</a>}
              {payment.flag_status === '3' && <a className="btn btn-danger" style={{color: 'white'}}>Cancelado/Negado</a>}
            </td>

                <td>{payment.link_boleto != null && <a href={payment.link_boleto} target="_blank" className="btn btn-primary">Boleto</a>}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  );

  };
  
  export default MeusPagamentosTable;